import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { commonActions } from '../../behavior/common/index';
import { NotificationBar } from 'react-lib/dist/components-es';

const NotificationBarComponent = ({ getNotification, notification }) => {
  const [isNotificationBarShown, updateIsNotificationBarShown] = useState(true);

  useEffect(() => {
    getNotification();
  }, []);

  return (
    <>
      {notification && isNotificationBarShown && (
        <NotificationBar
          notificationText={notification.text}
          updateIsNotificationBarShown={updateIsNotificationBarShown}
        />
      )}
    </>
  );
};

const mapStateToProps = state => ({
  notification: state.common.notification
});

const mapDispatchToProps = dispatch => ({
  getNotification: () => dispatch(commonActions.getNotification())
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBarComponent);
